<template>
  <div id="registro" class="zindex10">
    <section id="fondo">
      <div class="container">
        <div class="row pt-5 mb-4">
          <div
            class="col-12 pb-4 zindex10"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            &nbsp;
          </div>
        </div>
        <div class="row py-3">
          <div
            class="col-12 pb-4 zindex10"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            &nbsp;
          </div>
        </div>

        <div class="row">
          <div class="col-12 zindex10">
            <div class="row bgpestana">
              <img
                src="../assets/imgs/datumax/pestana-roja.png"
                alt="pestana"
                class="pestana"
              />

              <div class="col-12 bgazuloscuro borderrounded z100">
                <div class="row py-5">
                  <div class="col-12 text-center py-4 pt-5 blanco zindex10">
                    <h2 class="blanco fXXG bold">PREMIOS</h2>
                  </div>
                </div>

                <div class="row px-4 blanco">
                  <div class="col-12">

                    <div class="row pb-5">
                      <div
                        class="col-12 text-center pb-4 blanco zindex10 fXG azul bold"
                      >
                        PERIODO FINAL
                      </div>
                      <table
                        class="table table-bordered table-striped tablehighlight text-center align-middle"
                      >
                        <thead class="">
                          <tr>
                            <th>VIGENCIA</th>
                            <th>LUGAR</th>
                            <th>INCENTIVOS</th>
                            <th>CANTIDAD</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td rowspan="5">
                              13 de octubre al 07 de diciembre de 2025
                            </td>
                            <td>1° al 2° Lugar</td>
                            <td>
                              2 boletos al mundial para el Partido 1 – Grupo A
                              (México #1) - Estadio Azteca Ciudad de México
                            </td>
                            <td>2</td>
                          </tr>
                          <tr>
                            <td>3° al 4° Lugar</td>
                            <td>
                              2 boletos al mundial para el Partido 53 – Grupo A
                              (México #3) - Estadio Azteca Ciudad de México
                            </td>
                            <td>2</td>
                          </tr>
                          <tr>
                            <td>5° al 6° Lugar</td>
                            <td>
                              2 boletos al mundial para el Partido 12 – Grupo F
                              - Estadio Monterrey
                            </td>
                            <td>2</td>
                          </tr>
                          <tr>
                            <td>7° Lugar</td>
                            <td>Certificado con valor de $30,000.00 MX</td>
                            <td>1</td>
                          </tr>
                          <tr>
                            <td>8° al 12° Lugar</td>
                            <td>
                              Paquete doble para presenciar un partido amistoso
                              de la Selección Nacional Mexicana de futbol
                              varonil mayor en los Estados Unidos de América.
                              Incluye: 2 boletos de avión, hospedaje en la mejor
                              categoría disponible, 2 boletos de estadio
                              categoría 1 o 2 sujeto a disponibilidad,
                              transportación terrestre aeropuerto - hotel -
                              estadio - hotel - aeropuerto
                            </td>
                            <td>5</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    
                    <div class="row pb-5">
                      <div
                        class="col-12 text-center pb-4 blanco zindex10 fG azul bold"
                      >
                        PERIODO 1
                      </div>

                      <table
                        class="table table-bordered table-striped text-center align-middle"
                      >
                        <thead class="">
                          <tr>
                            <th>VIGENCIA</th>
                            <th>LUGAR</th>
                            <th>INCENTIVOS</th>
                            <th>CANTIDAD</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td rowspan="18">
                              13 de octubre al 26 de octubre de 2025
                            </td>
                            <td>1° Lugar</td>
                            <td>
                              iPhone 17 Pro de 256 GB con case del Mundial
                            </td>
                            <td>1</td>
                          </tr>
                          <tr>
                            <td>2° al 4° Lugar</td>
                            <td>Pantallas de 65" Smart TV</td>
                            <td>3</td>
                          </tr>
                          <tr>
                            <td>5° Lugar</td>
                            <td>
                              Boletos Partidos amistosos en MX | Acceso VIP
                            </td>
                            <td>1</td>
                          </tr>
                          <tr>
                            <td>6° al 10° Lugar</td>
                            <td>
                              Boletos Partidos amistosos en MX | Acceso
                              Preferente
                            </td>
                            <td>5</td>
                          </tr>
                          <tr>
                            <td>11° al 15° Lugar</td>
                            <td>
                              Boletos Partidos amistosos en MX | Acceso General
                            </td>
                            <td>5</td>
                          </tr>
                          <tr>
                            <td>16° al 17° Lugar</td>
                            <td>
                              Experiencia en evento privado en Alboa en Ciudad
                              de México (1 premio con un pase doble)
                            </td>
                            <td>2</td>
                          </tr>
                          <tr>
                            <td>18° al 22° Lugar</td>
                            <td>Balón marca Adidas World Cup PRO</td>
                            <td>5</td>
                          </tr>
                          <tr>
                            <td>23° al 27° Lugar</td>
                            <td>
                              Jersey Adidas Selección Nacional Mexicana color
                              verde
                            </td>
                            <td>5</td>
                          </tr>
                          <tr>
                            <td>28° al 42° Lugar</td>
                            <td>
                              Playeras de la Selección Nacional Mexicana
                              autografiada por jugadores
                            </td>
                            <td>15</td>
                          </tr>
                          <tr>
                            <td>43° al 57° Lugar</td>
                            <td>Playeras de la Selección Nacional Mexicana</td>
                            <td>15</td>
                          </tr>
                          <tr>
                            <td>58° al 59° Lugar</td>
                            <td>
                              Playeras de la Selección Nacional Mexicana
                              utilizada en un partido de la SNM y autografiada
                            </td>
                            <td>2</td>
                          </tr>
                          <tr>
                            <td>60° Lugar</td>
                            <td>
                              Experiencia visita en Centro de Alto Rendimiento
                              en CDMX para ver entrenamiento de la SNM (1 premio
                              con pase doble)
                            </td>
                            <td>1</td>
                          </tr>
                          <tr>
                            <td>61° al 70° Lugar</td>
                            <td>Hoodie marca Adidas - World Cup color verde</td>
                            <td>10</td>
                          </tr>
                          <tr>
                            <td>71° al 80° Lugar</td>
                            <td>Balón marca Adidas World Cup competition</td>
                            <td>10</td>
                          </tr>
                          <tr>
                            <td>81° al 90° Lugar</td>
                            <td>Hoodie Adidas DNA color verde</td>
                            <td>10</td>
                          </tr>
                          <tr>
                            <td>91° al 100° Lugar</td>
                            <td>Sudadera Adidas DNA crew sweat color verde</td>
                            <td>10</td>
                          </tr>
                          <tr>
                            <td>101° al 110° Lugar</td>
                            <td>Sudadera Adidas DNA crew sweat color ivory</td>
                            <td>10</td>
                          </tr>
                          <tr>
                            <td>111° al 270° Lugar</td>
                            <td>
                              Playera Adidas Selección Nacional Mexicana -
                              genérica hombre tamaño regular
                            </td>
                            <td>160</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="row pb-5">
                      <div
                        class="col-12 text-center pb-4 blanco zindex10 fG azul bold"
                      >
                        PERIODO 2
                      </div>
                      <table
                        class="table table-bordered table-striped text-center align-middle"
                      >
                        <thead class="">
                          <tr>
                            <th>VIGENCIA</th>
                            <th>LUGAR</th>
                            <th>INCENTIVOS</th>
                            <th>CANTIDAD</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td rowspan="18">
                              27 de octubre al 09 de noviembre de 2025
                            </td>
                            <td>1° Lugar</td>
                            <td>
                              iPhone 17 Pro de 256 GB con case del Mundial
                            </td>
                            <td>1</td>
                          </tr>
                          <tr>
                            <td>2° al 4° Lugar</td>
                            <td>Pantallas de 65" Smart TV</td>
                            <td>3</td>
                          </tr>
                          <tr>
                            <td>5° Lugar</td>
                            <td>
                              Boletos Partidos amistosos en MX | Acceso VIP
                            </td>
                            <td>1</td>
                          </tr>
                          <tr>
                            <td>6° al 10° Lugar</td>
                            <td>
                              Boletos Partidos amistosos en MX | Acceso
                              Preferente
                            </td>
                            <td>5</td>
                          </tr>
                          <tr>
                            <td>11° al 15° Lugar</td>
                            <td>Boletos Partidos amistosos en MX | Acceso</td>
                            <td>5</td>
                          </tr>
                          <tr>
                            <td>16° al 20° Lugar</td>
                            <td>Balón marca Adidas World Cup PRO</td>
                            <td>5</td>
                          </tr>
                          <tr>
                            <td>21° al 25° Lugar</td>
                            <td>
                              Jersey Adidas Selección Nacional Mexicana color
                              verde
                            </td>
                            <td>5</td>
                          </tr>
                          <tr>
                            <td>26° al 75° Lugar</td>
                            <td>
                              Playeras de la Selección Nacional Mexicana
                              autografiada por jugadores
                            </td>
                            <td>50</td>
                          </tr>
                          <tr>
                            <td>76° al 125° Lugar</td>
                            <td>Playeras de la Selección Nacional Mexicana</td>
                            <td>50</td>
                          </tr>
                          <tr>
                            <td>126° al 127° Lugar</td>
                            <td>
                              Playeras de la Selección Nacional Mexicana
                              utilizada en un partido de la SNM y autografiada
                            </td>
                            <td>2</td>
                          </tr>
                          <tr>
                            <td>128° Lugar</td>
                            <td>
                              Experiencia visita en Centro de alto rendimiento
                              en CDMX para ver entrenamiento de la SNM (1 premio
                              con pase doble)
                            </td>
                            <td>1</td>
                          </tr>
                          <tr>
                            <td>129° al 138° Lugar</td>
                            <td>Hoodie marca Adidas - World Cup color verde</td>
                            <td>10</td>
                          </tr>
                          <tr>
                            <td>139° al 148° Lugar</td>
                            <td>Balón marca Adidas World Cup competition</td>
                            <td>10</td>
                          </tr>
                          <tr>
                            <td>149° al 158° Lugar</td>
                            <td>Hoodie Adidas DNA color verde</td>
                            <td>10</td>
                          </tr>
                          <tr>
                            <td>159° al 168° Lugar</td>
                            <td>Sudadera Adidas DNA crew sweat color verde</td>
                            <td>10</td>
                          </tr>
                          <tr>
                            <td>169° al 178° Lugar</td>
                            <td>Sudadera Adidas DNA crew sweat color ivory</td>
                            <td>10</td>
                          </tr>
                          <tr>
                            <td>179° al 338° Lugar</td>
                            <td>
                              Playera Adidas Selección Nacional Mexicana -
                              genérica hombre tamaño regular
                            </td>
                            <td>160</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="row pb-5">
                      <div
                        class="col-12 text-center pb-4 blanco zindex10 fG azul bold"
                      >
                        PERIODO 3
                      </div>
                      <table
                        class="table table-bordered table-striped text-center align-middle"
                      >
                        <thead class="">
                          <tr>
                            <th>VIGENCIA</th>
                            <th>LUGAR</th>
                            <th>INCENTIVOS</th>
                            <th>CANTIDAD</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td rowspan="18">
                              10 de noviembre al 23 de noviembre de 2025
                            </td>
                            <td>1° Lugar</td>
                            <td>
                              iPhone 17 Pro de 256 GB con case del Mundial
                            </td>
                            <td>1</td>
                          </tr>
                          <tr>
                            <td>2° al 4° Lugar</td>
                            <td>Pantallas de 65" Smart TV</td>
                            <td>3</td>
                          </tr>
                          <tr>
                            <td>5° Lugar</td>
                            <td>
                              Boletos Partidos amistosos en MX | Acceso VIP
                            </td>
                            <td>1</td>
                          </tr>
                          <tr>
                            <td>6° al 10° Lugar</td>
                            <td>
                              Boletos Partidos amistosos en MX | Acceso
                              Preferente
                            </td>
                            <td>5</td>
                          </tr>
                          <tr>
                            <td>11° al 15° Lugar</td>
                            <td>
                              Boletos Partidos amistosos en MX | Acceso General
                            </td>
                            <td>5</td>
                          </tr>
                          <tr>
                            <td>16° al 20° Lugar</td>
                            <td>Balón marca Adidas World Cup PRO</td>
                            <td>5</td>
                          </tr>
                          <tr>
                            <td>21° al 25° Lugar</td>
                            <td>
                              Jersey Adidas Selección Nacional Mexicana color
                              verde
                            </td>
                            <td>5</td>
                          </tr>
                          <tr>
                            <td>26° al 75° Lugar</td>
                            <td>
                              Playeras de la Selección Nacional Mexicana
                              autografiada por jugadores
                            </td>
                            <td>50</td>
                          </tr>
                          <tr>
                            <td>76° al 125° Lugar</td>
                            <td>Playeras de la Selección Nacional Mexicana</td>
                            <td>50</td>
                          </tr>
                          <tr>
                            <td>126° Lugar</td>
                            <td>
                              Playeras de la Selección Nacional Mexicana
                              utilizada en un partido de la SNM y autografiada
                            </td>
                            <td>1</td>
                          </tr>
                          <tr>
                            <td>127° Lugar</td>
                            <td>
                              Experiencia visita en Centro de alto rendimiento
                              en CDMX para ver entrenamiento de la SNM (1 premio
                              con pase doble)
                            </td>
                            <td>1</td>
                          </tr>
                          <tr>
                            <td>128° al 137° Lugar</td>
                            <td>Hoodie marca Adidas - World Cup color verde</td>
                            <td>10</td>
                          </tr>
                          <tr>
                            <td>138° al 147° Lugar</td>
                            <td>Balón marca Adidas World Cup competition</td>
                            <td>10</td>
                          </tr>
                          <tr>
                            <td>148° al 149° Lugar</td>
                            <td>Balones usados y autografiados</td>
                            <td>2</td>
                          </tr>
                          <tr>
                            <td>150° al 159° Lugar</td>
                            <td>Hoodie Adidas DNA color verde</td>
                            <td>10</td>
                          </tr>
                          <tr>
                            <td>160° al 169° Lugar</td>
                            <td>Sudadera Adidas DNA crew sweat color verde</td>
                            <td>10</td>
                          </tr>
                          <tr>
                            <td>170° al 179° Lugar</td>
                            <td>Sudadera Adidas DNA crew sweat color ivory</td>
                            <td>10</td>
                          </tr>
                          <tr>
                            <td>180° al 359° Lugar</td>
                            <td>
                              Playera Adidas Selección Nacional Mexicana -
                              genérica hombre tamaño regular
                            </td>
                            <td>180</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    
                  </div>
                </div>
                <div class="row py-5">
                  <div class="col-12 text-center pb-4 blanco zindex10">
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="row py-5">
          <div class="col-12 text-center azul fXXG">GANADORES</div>
          <div class="col-12 text-center  azul fG py-2">Consulta la lista de ganadores semanales aquí:</div>
          <div class="col-12 text-center pb-5">
            <router-link
              to="/ganadores"
              class="amarillo pointer d-flex align-items-center justify-content-center btnaction fG ml-auto mr-auto w-100"
            >
              Lista de ganadores semanales
            </router-link>
          </div>
        </div> -->
      </div>
    </section>

    <PasswordReset
      v-if="showPasswordReset"
      @close="togglePasswordReset()"
    ></PasswordReset>

    <Footer></Footer>
  </div>
</template>

<script>
import PasswordReset from "@/components/PasswordReset";
import MonederoSet from "@/components/MonederoSet";

import Footer from "@/components/Footer";
import AOS from "aos";
import swal from "sweetalert2";

// import Parallax from "parallax-js";

import { mapState } from "vuex";
import moment from "moment";

import samsLogo from "../assets/imgs/flow/productos-participantes-sams.png";
import walmartLogo from "../assets/imgs/flow/productos-participantes-walmart.png";

import colgate1 from "../assets/imgs/datumax/productos/colgate-max-white.png";
import walmartPremios from "../assets/imgs/flow/premio-walmart.png";

import Vue from "vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
Vue.use(BootstrapVue);

export default {
  components: {
    PasswordReset,
    Footer,
  },
  data() {
    return {
      products: [
        {
          name: "Producto 1",
          description: "Este es el producto 1",
          image: "../assets/imgs/datumax/productos/colgate-max-white.png",
        },
        {
          name: "Producto 2",
          description: "Este es el producto 2",
          image: colgate1,
        },
        {
          name: "Producto 3",
          description: "Este es el producto 3",
          image: colgate1,
        },
        {
          name: "Producto 4",
          description: "Este es el producto 4",
          image: colgate1,
        },
      ],
      loginForm: {
        email: "",
        password: "",
      },
      signupForm: {
        nombre: "",
        apellido: "",
        email: "",
        celular: "",
        password: "",
        fecha_nacimiento: "",
        monedero: "",
        genero: "",
        terminosedad: "",
        terminos: "",
        terminoscondiciones: "",
        medio_de_contacto: "",
        estado: "",
      },
      showLoginForm: true,
      showPasswordReset: false,
      showMonedero: false,
      dateType: "text",
      explotar: true,
      showPasswordLogin: false, // Para login
      showPasswordSignup1: false, // Para signup password
      showPasswordSignup2: false, // Para signup confirm
    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation,
      disable: "mobile",
    });

    var scene = document.getElementById("scene");

    var vm = this;
    setTimeout(function () {
      vm.explotar = false;
      //var parallaxInstance = new Parallax(scene);
    }, 1000);
  },
  computed: {
    ...mapState(["userProfile"]),
    showNav() {
      return Object.keys(this.userProfile).length > 1;
    },
    logoSrc() {
      const tienda = process.env.VUE_APP_TIENDA;
      if (tienda === "sams") return samsLogo;
      if (tienda === "walmart") return walmartLogo;
      return "";
    },
    textoTienda() {
      const tienda = process.env.VUE_APP_TIENDA;
      if (tienda === "sams") return "Sam´s Club";
      if (tienda === "walmart") return "Walmart y Bodega Aurrera";
      return "";
    },
    groupedProducts() {
      const groups = [];
      for (let i = 0; i < this.products.length; i += 2) {
        groups.push(this.products.slice(i, i + 2));
      }
      return groups;
    },
  },
  methods: {
    cambiaFechaType() {
      this.dateType = "date";
      if (this.signupForm.fecha_nacimiento == "")
        this.signupForm.fecha_nacimiento = "1980-01-01";
    },
    toggleForm() {
      this.showLoginForm = !this.showLoginForm;
    },
    togglePasswordReset() {
      this.showPasswordReset = !this.showPasswordReset;
    },
    login(e) {
      e.preventDefault();

      this.$store.dispatch("login", {
        email: this.loginForm.email,
        password: this.loginForm.password,
      });

      // // // const https = require("https");
      // // // var qData = {
      // // //   email: this.loginForm.email,
      // // // };
      // // // this.$http
      // // //   .post(
      // // //     process.env.VUE_APP_API_URL + "login.php",
      // // //     JSON.stringify(qData),
      // // //     {
      // // //       emulateJSON: true,
      // // //       httpsAgent: new https.Agent({ rejectUnauthorized: false }),
      // // //       headers: {
      // // //         "Content-Type": "text/plain",
      // // //         //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
      // // //       },
      // // //     }
      // // //   )
      // // //   .then(
      // // //     (response) => {
      // // //       // get body data
      // // //       console.log("envio mail");
      // // //       console.log(response);

      // // //       let res = response.body;

      // // //       if (res.status == "ok") {
      // // //         this.$store.dispatch("login", {
      // // //           email: this.loginForm.email,
      // // //           password: this.loginForm.password,
      // // //         });
      // // //       } else {
      // // //         swal.fire("Oops", res.msg, "warning");
      // // //       }
      // // //     },
      // // //     (error) => {
      // // //       // error callback
      // // //       console.log("error callback");
      // // //       console.log(error);
      // // //     }
      // // //   );
    },
    signup(e) {
      e.preventDefault();

      // Validar contraseña
      if (this.validPass(this.signupForm.password) === false) {
        swal.fire(
          "Oops",
          "La contraseña debe tener al menos 8 dígitos",
          "warning"
        );
        return false;
      }

      // Confirmación de contraseña
      if (this.signupForm.password !== this.signupForm.password2) {
        swal.fire(
          "Oops",
          "La confirmación de contraseña no coincide con el campo de contraseña.",
          "warning"
        );
        return false;
      }

      // Validar teléfono
      if (this.validPhone(this.signupForm.celular) === false) {
        swal.fire(
          "Oops",
          "El celular debe ser un número válido de 10 dígitos.",
          "warning"
        );
        return false;
      }

      // Validar edad (18 años o más)
      if (!this.signupForm.fecha_nacimiento) {
        swal.fire("Oops", "Debes ingresar tu fecha de nacimiento.", "warning");
        return false;
      }

      const fechaNacimiento = moment(
        this.signupForm.fecha_nacimiento,
        "YYYY-MM-DD"
      );
      const hoy = moment();
      const edad = hoy.diff(fechaNacimiento, "years");

      if (edad < 18) {
        swal.fire(
          "Oops",
          "Debes tener al menos 18 años para registrarte.",
          "warning"
        );
        return false;
      }

      // Todo validado, registrar
      this.registro();
    },

    async registro(monedero = "") {
      this.$store.dispatch("showLoader", true);

      console.log({ registro: this.signupForm });

      // // // await this.enviaCorreo(
      // // //   this.signupForm.nombre,
      // // //   this.signupForm.apellido,
      // // //   this.signupForm.email
      // // // );

      await this.$store.dispatch("signup", this.signupForm);
    },
    async enviaCorreo(nombre, apellido, email) {
      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");
      var qData = {
        nombre: nombre,
        apellido: apellido,
        email: email,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "registro-prueba.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            console.log("envio mail");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              await this.$store.dispatch("signup", thes.signupForm);

              thes.$gtag.event("conversion", {
                send_to: "AW-978746627/-5dyCPTN_-IBEIP62dID",
              });

              //window.fbq("track", "CompleteRegistration");

              this.resetForm();
              this.toggleForm();
            } else {
              swal.fire("Oops", res.msg, "warning");
              this.resetForm();
              this.toggleForm();
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
          }
        );
    },
    resetForm() {
      this.signupForm = {
        nombre: "",
        apellido: "",
        email: "",
        celular: "",
        password: "",
        fecha_nacimiento: "",
        monedero: "",
        terminosedad: false,
        terminos: false,
        terminoscondiciones: false,
      };
    },
    validPass(password) {
      if (password.length < 8) {
        return false;
      }
      return true;
    },
    validPhone(celular) {
      if (celular.length < 10) {
        return false;
      }
      if (isNaN(celular)) {
        return false;
      }

      return true;
    },
  },
};
</script>
